// extracted by mini-css-extract-plugin
export default {"letterTitle":"IndexList_letterTitle__IkX4+","drugLink":"IndexList_drugLink__otSEj","italics":"IndexList_italics__y4phA"};